import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Timesheet',
  meta: {
    icon: 'fa-calendar',
    expanded: false,
    roles: Global.ALL_ROLE
  },

  children: [
    {
      name: 'My Timesheet',
      path: '/timesheet/new/:id',
      meta: {
        label: 'My Timesheet',
        roles: Global.ALL_ROLE,
        link: '/timesheet/new/'
      },
      component: lazyLoading('timesheet/Newtimesheet')
    },
    {
      name: 'OT Request',
      path: '/timesheet/OT-request/:id',
      meta: {
        label: 'OT Status',
        roles: Global.ALL_ROLE,
        link: '/timesheet/OT-request/'
      },
      component: lazyLoading('timesheet/OTRequest')
    },
    {
      name: 'Total OT',
      path: '/timesheet/OT-total',
      meta: {
        label: 'Total OT',
        roles: [Global.ROLE.ADMIN, Global.ROLE.ACCOUNTANT, Global.ROLE.GROUPMANAGER, Global.ROLE.IINCHO]
      },
      component: lazyLoading('timesheet/OTTotal')
    },
    {
      name: 'Absence List',
      path: '/timesheet/AbsenceList',
      meta: {
        label: 'Absence List',
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('timesheet/AbsenceList')
    },
    {
      name: 'Timesheet List',
      path: '/timesheet/TimesheetList',
      meta: {
          label: 'Timesheet List',
          roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('timesheet/TimesheetList')
    },
    {
      name: 'OT Manager Request',
      meta: {
        label: 'OT Manager Request',
        roles: [Global.ROLE.GROUPMANAGER, Global.ROLE.ADMIN]
      },
      path: '/timesheet/OTManagerRequest',
      component: lazyLoading('timesheet/OTManagerRequest')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/timesheet.js